// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PostCompanyRequestModel from '../../model/post-company-request-model';
import PostCompanyRequestDTO from '../dto/post-company-request-dto';
import dtoSchema from '../schemas/post-company-request-schema';
import CompanyRequestModel from '../../model/company-request-model';
import UserRequestModel from '../../model/user-request-model';

export default abstract class PostCompanyRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PostCompanyRequestDTO>) {
    super();
    if (data) {
      this.accessToken = data.accessToken ?? undefined;
      this.company = data.company ? CompanyRequestModel.toModel(data.company) : undefined;
      this.user = data.user ? UserRequestModel.toModel(data.user) : undefined;
      this.eventIdentifier = data.eventIdentifier;
      this.existingCompanyId = data.existingCompanyId;
    }
  }
  /**
  */
  accessToken?: string;
  /**
  */
  company?: CompanyRequestModel;
  /**
  */
  user?: UserRequestModel;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  * @type {uuid}
  */
  existingCompanyId?: string;

  static toModel(dto: DeepPartial<PostCompanyRequestDTO>): PostCompanyRequestModel;
  static toModel(dto: DeepPartial<PostCompanyRequestDTO> | undefined | null): PostCompanyRequestModel | undefined;
  static toModel(dto: DeepPartial<PostCompanyRequestDTO> | undefined | null): PostCompanyRequestModel | undefined {
    return dto ? new PostCompanyRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PostCompanyRequestModel> | PostCompanyRequestModel): PostCompanyRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      accessToken: unwrapped.accessToken,
      company: unwrapped.company,
      user: unwrapped.user,
      eventIdentifier: unwrapped.eventIdentifier,
      existingCompanyId: unwrapped.existingCompanyId,
    } as PostCompanyRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PostCompanyRequestModel, can not map to PostCompanyRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
